// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"c03ed0fdc692d589502d","966":"ece9e8fa5a7d72d73689"}[chunkId] + ".js";
};